// extracted by mini-css-extract-plugin
export default {"wrapper":"siteNotFound_wrapper__mvZII","content":"siteNotFound_content__IxxMl","icon":"siteNotFound_icon__dJF7r"};